// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__Zmaog","actions":"GroupTable_actions__3K4po","deleteModalFooter":"GroupTable_deleteModalFooter__2nlPe"};